import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left-heavy",
  "use": "icon-chevron-left-heavy-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 7 12\" id=\"icon-chevron-left-heavy\">\r\n<path d=\"M6,0c0.3,0,0.5,0.1,0.7,0.3c0.4,0.4,0.4,1,0,1.4L2.4,6l4.3,4.3c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0l-5-5c-0.4-0.4-0.4-1,0-1.4\r\n\tl5-5C5.5,0.1,5.7,0,6,0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol